import { render, staticRenderFns } from "./SortModel.vue?vue&type=template&id=5e430142&scoped=true&"
import script from "./SortModel.vue?vue&type=script&lang=js&"
export * from "./SortModel.vue?vue&type=script&lang=js&"
import style0 from "./SortModel.vue?vue&type=style&index=0&id=5e430142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e430142",
  null
  
)

export default component.exports